import { useAnalytics } from '@/services/analytics';
import { useMountEffect } from '@/hooks/state/use-mount-effect';
import { AgentFooterBar } from './agent-footer-bar';

/** The agent entry point in the app footer: the agent footer bar with chips for recent conversations. */
export function AgentLauncher() {
  const { track } = useAnalytics();

  // Exposure event, fired whether or not the user ever opens the agent: the
  // denominator for launcher open and message rates.
  useMountEffect(() => {
    void track('aiAssistant', 'launcherDisplayed', { Variant: 'bar' });
  });

  return <AgentFooterBar />;
}
